/**
 * Axios Auth Interceptor
 *
 * Automatically adds Bearer token (Azure AD id_token) to all axios requests
 * targeting the AI Engine. Import this file once in App.js to activate.
 */
import axios from 'axios';
import { getAuthHeaders } from './authHelpers';
import { AI_ENGINE_URL } from './apiConfig';

axios.interceptors.request.use(async (config) => {
  // Only add auth headers for AI Engine direct calls
  if (config.url && config.url.startsWith(AI_ENGINE_URL)) {
    const authHeaders = await getAuthHeaders();
    Object.assign(config.headers, authHeaders);
  }
  return config;
});
